import { Accordion } from "react-bootstrap"
import { FORM_KEYS, validFileTypes } from "./helper";
import Select from 'react-select';
import UploadFile from "../../../../utilsComponent/Upload";
import { useEffect, useState } from "react";
import { uploadDocuments } from "./apiHelper";
import { toast } from "react-toastify";


const Documents = ({ customStyles, setValue, formData, policyData, setLoading, documentTypes }) => {
    const [disableAddButton, setDisableAddButton] = useState(false)
    const [documents, setDocuments] = useState(formData[FORM_KEYS.document_ids])

    const handleUpload = async (files, documentDetails, index) => {
        const response = await uploadDocuments(policyData.policy_no, documentDetails.documentType?.value, files, setLoading);
        const newFiles = response.documents.map((document, index) => {
            return {
                id: document.documentId,
                docURL: document.docURL,
                name: files[index]?.name,
                fileType: decodeURIComponent(document.docURL)
                    .split('?')[0]
                    .split('/')
                    .pop()
                    .split('.')
                    .pop()
            }
        })
        const updatedDocuments = [...documents];

        updatedDocuments[index].docs = [...updatedDocuments[index].docs, ...newFiles]
        setDocuments(updatedDocuments);
    }

    const handleDocSectionDelete = (indexToDelete) => {
        setDocuments((prev) => (prev.filter((_, index) => index !== indexToDelete)))
    }

    const handleFileDelete = (fileId, index) => {
        const updatedDocs = [...documents];
        updatedDocs[index].docs = updatedDocs[index].docs.filter(file => file.id !== fileId)
        setDocuments(updatedDocs)
    }

    const handleAddDocSection = () => {
        const newDocSection = {
            documentType: null,
            docs: []
        }
        setDocuments((prev) => ([...prev, newDocSection]))
    }

    const handleDocumentTypeChange = (data, index) => {
        // check the document type is already selected
        if (documents.some((document, docIndex) => document.documentType?.value === data?.value && docIndex != index)) {
            toast.error("This Attachment Type is already Selected")
        } else {
            const updatedDocs = [...documents]
            updatedDocs[index].documentType = data
            setDocuments(updatedDocs)
        }
    }

    useEffect(() => {
        const lastDocumentDetails = documents[documents.length - 1]
        if (lastDocumentDetails.documentType && lastDocumentDetails.docs.length) {
            setDisableAddButton(false)
        } else {
            setDisableAddButton(true)
        }
        setValue(FORM_KEYS.document_ids, documents)
    }, [documents])
    return <>
        {documents.map((documentDetails, index) => (
            <Accordion className='accordion m-2' defaultActiveKey="0" key={index}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <span>Document - {index + 1}</span>
                            {documents.length > 1 && (<i
                                className="fa fa-trash text-danger pe-4 cursor-pointer"
                                onClick={() => handleDocSectionDelete(index)}
                                title="Delete"
                            ></i>)}
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <p className="align3Policy">Attachment Type </p>
                                <Select
                                    options={documentTypes}
                                    className="ms-2"
                                    classNamePrefix="truncate-placeholder"
                                    placeholder="Select Attachment Type"
                                    // value={formData[FORM_KEYS.attachment_type]}
                                    value={documentDetails.documentType}
                                    onChange={(data) => {
                                        handleDocumentTypeChange(data, index)
                                    }}
                                    isDisabled={documents[index].docs.length}
                                    styles={customStyles}
                                    isClearable
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12">
                                {documentDetails.documentType && (
                                    <UploadFile
                                        index={index}
                                        validType={validFileTypes}
                                        mandatory={true}
                                        addedFiles={documentDetails?.docs}
                                        onFileChange={(files) => handleUpload(files, documentDetails, index)}
                                        // setAddedFiles={setUploadedFiles}
                                        onFileRemove={(fileId) => handleFileDelete(fileId, index)}
                                        text={documentDetails.documentType?.label}
                                        label="Attachment"
                                        showFilePreview
                                    />
                                )}
                            </div></div>
                        {
                            index === (documents.length - 1) && (
                                <div className="mt-4">
                                    <div className="d-flex gap-2">
                                        <button
                                            className="btn btn-success"
                                            onClick={handleAddDocSection}
                                            disabled={disableAddButton}
                                        >
                                            Add more documents
                                        </button>
                                    </div>
                                </div>
                            )
                        }
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        ))}
    </>;
}

export default Documents;